import React, { useCallback, useState } from 'react';
import { Button, Clickable } from '@moda/om';
import ExitIcon from '@moda/icons/exit-20';
import FilterIcon from '@moda/icons/filter-16';
import { ProductListPageResultFragment } from '../../../generated/types/ProductListPageResultFragment';
import { GuidePageQuery_displayPage as DisplayPage } from '../../../generated/types/GuidePageQuery';
import { ModalOverlay } from '../../Modal';
import { PageFilter, PageFilterClear } from '../../PageFilter';

import './ProductListingMobile.scss';

type ProductListingMobileFilterProps = {
  queryResult?: Partial<ProductListPageResultFragment> | null;
  displayPage?: DisplayPage | null;
  showPriceFilter?: boolean;
  showCounts?: boolean;
};

export const ProductListingMobileFilter: React.FC<ProductListingMobileFilterProps> = ({
  queryResult,
  displayPage,
  showPriceFilter,
  showCounts = true
}) => {
  const [filterOpen, setFilterOpen] = useState(false);
  const closeFilter = useCallback(() => setFilterOpen(false), []);
  const openFilter = useCallback(() => setFilterOpen(true), []);

  return (
    <>
      <Clickable className="ProductListingMobile__action" onClick={openFilter}>
        <span className="ProductListingMobile__actionText">Filter</span>
        <FilterIcon className="ProductListingMobile__actionIcon" />
      </Clickable>

      {filterOpen && (
        <ModalOverlay className="ProductListingMobile__modal" onClose={closeFilter}>
          <div className="ProductListingMobile__panelFilter">
            <Clickable className="ProductListingMobile__panelClose" onClick={closeFilter}>
              <ExitIcon />
            </Clickable>
            <div className="ProductListingMobile__panelTitle">Refine By</div>
            <PageFilterClear
              attributes={queryResult?.attributes || []}
              designers={queryResult?.designers || []}
              sizes={queryResult?.sizes || []}
              categoryTree={queryResult?.categoryTree || null}
            />
            <PageFilter
              attributes={queryResult?.attributes || []}
              availability={queryResult?.availability || null}
              categoryTree={queryResult?.categoryTree || null}
              colors={queryResult?.filterColors || []}
              designers={queryResult?.designers || []}
              mobile
              showPriceFilter={showPriceFilter}
              showCounts={showCounts}
              onClose={closeFilter}
              sizes={queryResult?.sizes || []}
              guideSubPages={displayPage?.guideSubPages || null}
            />
            <Button className="ProductListingMobile__submit" onClick={closeFilter}>
              {showCounts
                ? `SEE ${queryResult?.totalItems || 0} RESULT${
                    queryResult?.totalItems === 1 ? '' : 'S'
                  }`
                : 'SEE RESULTS'}
            </Button>
          </div>
        </ModalOverlay>
      )}
    </>
  );
};
